import { PlanSourceType } from '@ebalance/proto/bfftypes/v1/plan_submission_pb'

/**
 * PlanSourceType の日本語ラベルマップ。
 * counterpartyCode / counterpartyName が無い場合（JEPX スポット等）の
 * 列ヘッダ表示フォールバックとして使用する。
 * 文言は i18n（page:generationSalesPlanDetail.sourceType.*）経由で使うため、
 * この定数は i18n キーのマッピング用（ProcurementPlanDetail/constants.ts と同構造）。
 */
export const PLAN_SOURCE_TYPE_I18N_KEYS: Record<PlanSourceType, string> = {
  [PlanSourceType.UNSPECIFIED]:
    'page:generationSalesPlanDetail.sourceType.unspecified',
  [PlanSourceType.BG_BILATERAL]:
    'page:generationSalesPlanDetail.sourceType.bgBilateral',
  [PlanSourceType.E_CLEAR]: 'page:generationSalesPlanDetail.sourceType.eClear',
  [PlanSourceType.JEPX_SPOT]:
    'page:generationSalesPlanDetail.sourceType.jepxSpot',
  [PlanSourceType.JEPX_INTRADAY]:
    'page:generationSalesPlanDetail.sourceType.jepxIntraday',
  [PlanSourceType.CONSTANT_BACKUP]:
    'page:generationSalesPlanDetail.sourceType.constantBackup',
  [PlanSourceType.FIT_FIP]: 'page:generationSalesPlanDetail.sourceType.fitFip',
  [PlanSourceType.SELF_WHEELING]:
    'page:generationSalesPlanDetail.sourceType.selfWheeling',
}
